import React from "react";
import { DownOutlined } from "@ant-design/icons";
import moment from "moment";

import {
  DatePicker,
  // TimePicker,
} from "antd";

const DateInput: React.FC<any> = ({
  value = undefined,
  placeholder,
  onChange,
  disabled = false
}) => {
  return (
    <DatePicker
      value={value ? moment(value, "MM/DD/YYYY HH:mm:ss") : undefined}
      onChange={(date: moment.Moment | null) => {
        onChange(date?.format("MM/DD/YYYY HH:mm:ss"));
      }}
      disabled={disabled}
      placeholder={placeholder}
      suffixIcon={<DownOutlined />}
    />
  );
};

export default DateInput;